<script>
import { onMount } from "svelte";

  import WaitingFor from "./components/WaitingFor.svelte";
  export let stats;
  let ss;

  onMount(async () => {
    ss = await stats.stats;
    // stats.emails = await backend.run('telekinesis-inc/register').stats();
  })
</script>

{#if ss}
  {#each Object.entries(ss) as [k, v]}
    {k}: unique: {v.unique}  total: {v.total}
    <br>
  {/each}
{:else}
  <WaitingFor />
{/if}